/**
 * Timepicker Class
 *
 */
export default class Timepicker {


    // constructor
    constructor(selector) {
        this.timePicker(selector);
    }

    // init timepicker
    timePicker(selector) {
        let vm = $(selector);
        vm.picker = '[data-timepicker]';
        vm.pickerToggle = '[data-timepicker-toggle]';
        vm.pickerToggleIcon = 'ui_clock_o';
        vm.pickerToggleCloseIcon = 'ui_close';

        vm.find(vm.picker).each(function() {
            let $this = $(this);
            let pickadate = $this.pickatime({
                clear: tncpConstants.pickadate.clear,
                close: tncpConstants.pickadate.close,
                format: tncpConstants.pickadate.formatTime,
                formatSubmit: tncpConstants.pickadate.formatTimeSubmit,
                interval: 15,
                min: [9,0],
                max: [16,0],
                onOpen: function() {
                    $this.nextAll(vm.pickerToggle).attr( 'data-icon', vm.pickerToggleCloseIcon );
                },
                onClose: function() {
                    $this.nextAll(vm.pickerToggle).attr( 'data-icon', vm.pickerToggleIcon );
                }
            });
            let picker = pickadate.pickatime('picker');

            $this.removeAttr('readonly');
            picker.set('editable', true);
            $this.nextAll(vm.pickerToggle).
            on( 'click', function( event ) {
                if ($this.hasClass('picker__input--active')) {
                    picker.close()
                } else {
                    $this.focus();
                }
                event.preventDefault();
                event.stopPropagation()
            }).
            on( 'mousedown', function(event) {
                event.preventDefault()
            });

        });
    }

}
